"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
exports.__esModule = true;
var angular = require("angular");
var envelope_chart_chart_1 = require("../envelope-chart/envelope-chart.chart");
var basic_chart_component_1 = require("../basic-component/basic-chart.component");
var portfolio_uncertainty2_poland_logic_1 = require("../portfolio-uncertainty2/portfolio-uncertainty2.poland.logic");
var envelope_chart_logic_1 = require("../envelope-chart/envelope-chart.logic");
var AddEnvelopeComponent = /** @class */ (function (_super) {
    __extends(AddEnvelopeComponent, _super);
    function AddEnvelopeComponent($scope, $timeout) {
        var _this = 
        // This constructor is necessary for inject scope and timeout.
        _super.call(this, $scope, $timeout, 'AddEnvelope') || this;
        var ctrl = _this;
        $scope.$on('export:csv', function (event, args, callback) {
            var csv = envelope_chart_logic_1.EnvelopeChartLogic.downloadCsv(angular.copy(ctrl.selectedGraph), args.filename, args.csvFormat, args.skipSave || false);
            if (callback) {
                callback(csv);
            }
        });
        $scope.$on('command:ADD_ENVELOPE', function (event, args) {
            ctrl.actionMenuItem = args.actionMenuItem;
            var settings = args.config.data.data.settings;
            var config = args.config.data.data.data;
            var years = args.config.data.data.years;
            var shadowNodeName = args.compareToNode ? args.compareToNode.name : null;
            var tenFiftyNinety = [];
            settings.currentFit = 'Monte Carlo';
            config.DataForEachKey.forEach(function (d) {
                var graphAndTable = portfolio_uncertainty2_poland_logic_1.appendPolandDataToGraph(JSON.parse(JSON.stringify(d)), settings);
                tenFiftyNinety.push(graphAndTable.table);
            });
            if (tenFiftyNinety.length == years.length) {
                var addEnvelopeChartData_1 = [];
                var addEnvelopeShadowChartData_1 = [];
                years.forEach(function (year, i) {
                    addEnvelopeChartData_1.push([year, tenFiftyNinety[i].mainRows[0]['ten'],
                        tenFiftyNinety[i].mainRows[0]['fifty'], tenFiftyNinety[i].mainRows[0]['ninety']]);
                    if (tenFiftyNinety[i].siblingRows.length > 0) {
                        addEnvelopeShadowChartData_1.push([year, tenFiftyNinety[i].siblingRows[0]['ten'],
                            tenFiftyNinety[i].siblingRows[0]['fifty'], tenFiftyNinety[i].siblingRows[0]['ninety']]);
                    }
                });
                addEnvelopeChartData_1 = envelope_chart_logic_1.EnvelopeChartLogic.addMissingRow(addEnvelopeChartData_1);
                addEnvelopeShadowChartData_1 = (tenFiftyNinety[0].siblingRows.length > 0) ?
                    envelope_chart_logic_1.EnvelopeChartLogic.addMissingRow(addEnvelopeShadowChartData_1) :
                    addEnvelopeShadowChartData_1;
                var envelopeArgs = angular.copy(args);
                envelopeArgs['config']['data']['data'] = [{
                        'mainRows': addEnvelopeChartData_1,
                        'siblingRows': addEnvelopeShadowChartData_1,
                        'nodeName': args.nodeName,
                        'siblingNodeName': shadowNodeName
                    }];
                ctrl.initComponent(event, envelopeArgs);
            }
        });
        return _this;
    }
    AddEnvelopeComponent.prototype.getChartOptions = function (graph, options) {
        return envelope_chart_chart_1.getChartOptions(graph, options);
    };
    AddEnvelopeComponent = __decorate([
        basic_chart_component_1.Component({
            bindings: {
                menu: '='
            },
            template: require("../envelope-chart/envelope-chart.component.html")
        }),
        __metadata("design:paramtypes", [Object, Object])
    ], AddEnvelopeComponent);
    return AddEnvelopeComponent;
}(basic_chart_component_1.BasicChartComponent));
exports.AddEnvelopeComponent = AddEnvelopeComponent;
angular.module('smartorg.r6.acts.addEnvelope', []).filter('textOrNumber', ['$filter', function ($filter) {
        return function (input, fractionSize) {
            if (isNaN(input) || (fractionSize == "Default")) {
                return input;
            }
            else {
                return $filter('number')(input, fractionSize);
            }
        };
    }]).component('addEnvelope', AddEnvelopeComponent);
module.exports = 'smartorg.r6.acts.addEnvelope';
//# sourceMappingURL=add-envelope.component.js.map


// WEBPACK FOOTER //
// ./app/widgets/action/add-envelope/add-envelope.component.js